import React, { useState } from "react";
import { useFormik } from "formik";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Container,
  Row,
  Col,
  CardImg,
} from "reactstrap";
import { RegisterApi } from "network/user";
import { useNavigate } from "react-router-dom";
import { ErrorToaster } from "components/common/toast";
import InputPassword from "components/common/input-password";
import { useTranslation } from "react-i18next";
import BtnCustom from "components/common/btn-custom";
import CustomInput from "components/common/AuthInput";
import handleError from "utils/handleError";
import PATHS from "constant/paths";
import { RegisterSchema } from "components/schema/RegisterSchema";
import ModalUploadProfile from "components/modal/modalUploadProfile";
import { successToaster } from "components/common/toast";

const Register = () => {
  const { t } = useTranslation("auth");
  const [open, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const navigate = useNavigate();

  const handleModel = () => {
    setOpen(!open);
  };
  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setFieldValue,
    isSubmitting,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      profile: "",
    },
    enableReinitialize: true,
    validationSchema: RegisterSchema,
    onSubmit: async (values) => {
      try {
        const formData = new FormData();

        formData.append("first_name", values.firstName);
        formData.append("last_name", values.lastName);
        formData.append("email", values.email);
        formData.append("phone_number", values.phone);
        formData.append("role", "user");
        formData.append("password", values.password);
        formData.append("confirm_password", values.confirmPassword);
        if (values.profile && confirm) {
          formData.append("profile_url", values.profile);
        }

        const response = await RegisterApi(formData);
        if (response.success) {
          successToaster(t("register.success"));
          navigate(PATHS.LOGIN);
        }
      } catch (error) {
        ErrorToaster(handleError(error.status_code, error.message));
      }
    },
  });
  return (
    <div className="content">
      <Container>
        <Row>
          <Col md="7" className="mx-auto d-flex justify-content-center">
            <Card className="card-register card-white">
              <CardHeader className="pb-0">
                <CardImg
                  alt="..."
                  src={require("assets/img/card-primary.png")}
                />
                <CardTitle tag="h6" className="text-capitalize text-center">
                  {t("register.title")}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <CustomInput
                    icon={<i className="tim-icons icon-single-02" />}
                    name="firstName"
                    placeholder={t("register.firstName")}
                    type="text"
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                  <CustomInput
                    icon={<i className="tim-icons icon-single-02" />}
                    name="lastName"
                    placeholder={t("register.lastName")}
                    type="text"
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                  <CustomInput
                    icon={<i className="tim-icons icon-mobile" />}
                    name="phone"
                    placeholder={t("register.phone")}
                    type="text"
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                  <CustomInput
                    icon={<i className="tim-icons icon-email-85" />}
                    name="email"
                    placeholder={t("register.email")}
                    type="email"
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                  <InputPassword
                    icon={<i className="tim-icons icon-lock-circle" />}
                    name="password"
                    placeholder={t("register.password")}
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                  <InputPassword
                    icon={<i className="tim-icons icon-lock-circle" />}
                    name="confirmPassword"
                    placeholder={t("register.confirmPassword")}
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                  <div className="text-right">
                    <Button
                      color="primary"
                      onClick={handleModel}
                      disabled={confirm}
                    >
                      {t("register.uploadProfile")}
                    </Button>
                  </div>
                  <CardFooter className="text-center">
                    <BtnCustom
                      className="btn-round"
                      color="primary"
                      size="lg"
                      type="submit"
                      isLoading={isSubmitting}
                      submittingText={t("register.registering")}
                    >
                      {t("register.submit")}
                    </BtnCustom>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ModalUploadProfile
          setFieldValue={setFieldValue}
          value={values.profile}
          open={open}
          setOpen={setOpen}
          setConfirm={setConfirm}
        />
      </Container>
    </div>
  );
};

export default Register;
